import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import { FaExchangeAlt, FaPercentage, FaUser } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { LoggedUser } from "../../../atoms/userLogged";
import { BLUECARD, REDMONEDD } from "../../../constants/colors";
import {
  goToPersonalData,
  goToTarifasCliente,
} from "../../../routes/coordinator";
import ModalChangePassword from "./modalChangePassword";
import ModalLogout from "./modalLogout";

const ProfileDrawer = ({ isOpen, setIsOpen }: any) => {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const navigate = useNavigate();

  const user = useRecoilState(LoggedUser)[0];
  const [openChangePassword, setOpenChangePassword] = useState(false);

  return (
    <>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay backdropFilter="blur(10px)" />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            Olá,{" "}
            {user.nome
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})/g, (letra) =>
                letra.toUpperCase()
              )}{" "}
          </DrawerHeader>
          <DrawerBody p={6} justifyContent={"space-between"}>
            <Flex flexDirection={"column"}>
              <Button
                style={{ color: "white" }}
                leftIcon={<FaUser />}
                height="30px"
                onClick={() => {
                  goToPersonalData(navigate);
                  setIsOpen(false);
                }}
                width="200px"
                backgroundColor={BLUECARD}
                my={2}
              >
                Meus Dados
              </Button>
              <Button
                style={{ color: "white" }}
                background={REDMONEDD}
                onClick={() => setOpen(true)}
                rightIcon={<FiLogOut />}
                height="30px"
                width="100px"
                my={2}
              >
                Sair
              </Button>
            </Flex>
          </DrawerBody>
          <DrawerFooter></DrawerFooter>
          <ModalLogout isOpen={open} setIsOpen={setOpen} />
          <ModalChangePassword
            isOpen={openChangePassword}
            setIsOpen={setOpenChangePassword}
            user={user}
          />
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default ProfileDrawer;
